
import { mapGetters } from 'vuex'
import MachinationsLightPage from '~/domain/pages/MachinationsLightPage'
import { IWpRawPost, IWpDetailedPost } from '@interfaces/WpTypes'

export default MachinationsLightPage.extend({
  layout: 'blog',
  computed: {
    wpBusy() {
      return this.$store.state.wp.isBusy
    },
    wpPosts(): IWpDetailedPost[] | IWpRawPost[] {
      return this.$store.state.wp.posts
    },
    ...mapGetters({
      wpPagination: 'wp/wpPagination',
    }),
  },
  head() {
    // @ts-ignore
    const pageHead = this.pageHead()
    return {
      ...pageHead,
      // @ts-ignore
      title: `${this.$t('wordCapitalArticles')} • ${pageHead.title}`,
    }
  },
  methods: {
    async pageChanged(pageNumber: number) {
      if (pageNumber === 1) {
        this.$router.push(
          `/articles/category/${this.$route.params.slugCategory}`
        )
      } else {
        this.$router.push(
          `/articles/category/${this.$route.params.slugCategory}/page/${pageNumber}`
        )
      }
    },
  },
  async asyncData(context) {
    const { $config, store, params, error, route } = context
    const { wpBaseURL } = $config

    if (Object.keys(store.state.wp.categories).length === 0) {
      await store.dispatch('wp/getCategories', context)
    }

    const categoryId = store.state.wp.categoriesSlugs[params.slugCategory]

    if (!categoryId) {
      error({
        statusCode: 404,
        message: `Invalid route: ${route.path}`,
      })
    }

    const currentCategory = store.state.wp.categories[categoryId]

    store.commit('wp/updatePageTitle', currentCategory.name)
    store.commit('wp/updatePageHead', currentCategory.yoast_head_json)

    const pageNumberParam = Number(params.pageNumber)
    const pageNumber =
      isNaN(pageNumberParam) ||
      !isFinite(pageNumberParam) ||
      pageNumberParam <= 0
        ? 1
        : Math.floor(pageNumberParam)
    await store.commit('wp/setPageNumber', pageNumber)

    await store.dispatch('wp/getPostsForCategory', {
      context,
      wpBaseURL,
      currentCategory,
    })

    await store.commit('wp/updateBusy', false)
    await store.dispatch('common/fetchMenu', context)
  },
})
